import { Popup } from 'react-map-gl/mapbox'
import type { PopoverInfo } from '../../types'
import { Texto, Vertical } from '@gravitate-js/excalibrr'

type PoiPopoverProps = {
  hoverInfo: PopoverInfo | null
  mapRef: React.MutableRefObject<mapboxgl.Map | null>
}

export function PoiPopover({ hoverInfo, mapRef }: PoiPopoverProps) {
  if (hoverInfo === null || hoverInfo.popoverType !== 'poi') {
    return null
  }

  return (
    <Popup
      longitude={hoverInfo.lon}
      latitude={hoverInfo.lat}
      closeButton={false}
      closeOnClick={false}
      anchor='bottom'
      offset={(mapRef.current?.getZoom() || 0) > 10 ? [0, -38] : [0, -9]}
      className='mapbox-popover'
    >
      <Vertical gap={4}>
        <Texto category='h4' appearance='hint'>
          {hoverInfo.locationType}
        </Texto>
        <PopoverRow
          label='Name'
          value={`${hoverInfo.location} ${hoverInfo?.siteName ? hoverInfo.siteName : ''}`}
          category='h5'
        />
        {hoverInfo.address && (
          <PopoverRow
            label='Address'
            value={`${hoverInfo.address}, ${hoverInfo.city}, ${hoverInfo.state} ${hoverInfo.postalCode}`}
          />
        )}
        {hoverInfo.radius && <PopoverRow label='Geofence Radius' value={`${hoverInfo.radius} miles`} />}
      </Vertical>
    </Popup>
  )
}

type PopoverRowProps = {
  label: string
  value: string | number | React.ReactNode
  category?: 'p2' | 'label' | 'h5'
}
export function PopoverRow({ label, value, category = 'p2' }: PopoverRowProps) {
  return (
    <Vertical>
      <Texto category={'p2'} weight={'bold'}>
        {label}
      </Texto>
      <Texto category={category}>{value}</Texto>
    </Vertical>
  )
}
